import { render } from "./CrudCosts.vue?vue&type=template&id=30f2ee38&scoped=true"
import script from "./CrudCosts.vue?vue&type=script&lang=js"
export * from "./CrudCosts.vue?vue&type=script&lang=js"

import "./CrudCosts.vue?vue&type=style&index=0&id=30f2ee38&lang=css"
import "./CrudCosts.vue?vue&type=style&index=1&id=30f2ee38&scoped=true&lang=postcss"

import exportComponent from "C:\\Users\\Bodnár Lajos\\Documents\\Work\\Vue.JS\\otthonapolo2020-FE-V3\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f2ee38"]])

export default __exports__